import $ from 'jquery';

class cdpInsightProfilesWithUnansweredTickets{
  constructor() {
    if ($('#cdp-insight-profiles-with-unanswered-tickets').length > 0){
      this.loading()
      this.init()
    }
  }

  init(){
    var cdpStat = this;
    $(document).ready(function() {
      setTimeout(function() {
        var result = { query: JSON.stringify(SegmentQueryBuilder.getMongoQuery()) };
        $.ajax({
          url: $('#cdp-insight-profiles-with-unanswered-tickets').data('url'),
          method: 'GET',
          data: result,
          success: function (response) {
            cdpStat.renderStats(response)
          }
        });
      }, 1000);
    })
  }

  renderStats(response){
    $('#cdp-insight-profiles-with-unanswered-tickets .card-body .card-body h4').text(this.transform(response.profiles_count));
    $('#cdp-insight-profiles-with-unanswered-tickets .card-body .card-text').html(`<b>${this.transform(response.profiles_count)}</b> участников промо имеют просроченные или не отвеченные тикеты обратной связи. Возможно, вы хотели бы просмотреть их.`);
    $('#cdp-insight-profiles-with-unanswered-tickets .peity-donut').text(`${response.profiles_percentage}/100`);
    $('#cdp-insight-profiles-with-unanswered-tickets .peity-donut').peity('donut');
    this.loaded();
    this.toggleActionBtn(response.profiles_count);
  }

  toggleActionBtn(profiles_count){
    if (profiles_count > 0){
      $('#cdp-insight-profiles-with-unanswered-tickets .open-new-insight-segment-modal').removeClass('d-none');
    } else {
      $('#cdp-insight-profiles-with-unanswered-tickets .open-new-insight-segment-modal').addClass('d-none');
    }
  }

  loading(){
    $('#cdp-insight-profiles-with-unanswered-tickets').addClass('loading');
  }

  loaded(){
    $('#cdp-insight-profiles-with-unanswered-tickets').removeClass('loading');
  }

  transform(number) {
    return parseFloat(number).toLocaleString("ru")
  }
}

export default cdpInsightProfilesWithUnansweredTickets;